import { useEffect, useState } from 'react'

const useUnlockClickedButton = (instanceId?: string): boolean => {
  const [current, setCurrent] = useState<boolean>(true)

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_unlockClickedButton', (e) => handleChange(e))
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_unlockClickedButton'))

    return () => {
      document.removeEventListener('retorik_unlockClickedButton', (e) => handleChange(e))
    }
  }, [])

  return current
}

export default useUnlockClickedButton
